import { LoggedUser } from 'entities/modules/types';
import { FullProject, FullTask, Project, ProjectFile, ProjectTask, TaskFile } from '../types';
import { isLeader, isOwner } from 'entities/modules/utils';
import { projectStatusByCode, taskStatusByCode } from '../configs';

export function canUpdateTaskFile({
  file,
  project,
  task,
  user,
}: {
  project: Project | FullProject;
  task: ProjectTask | FullTask;
  file: TaskFile;
  user: LoggedUser;
}) {
  const statusOk =
    projectStatusByCode[project.status].isActiveStatus &&
    taskStatusByCode[task.status].isActiveStatus;

  const ownershipOk =
    isOwner(project, user) ||
    isOwner(task, user) ||
    file.uploadedBy.id === user.id ||
    (isLeader(user) && task.team === user.team.id);

  return statusOk && ownershipOk;
}

export function isImageFile(file: ProjectFile | TaskFile) {
  // image.png is the default name when user pastes from comment etc
  return file.filename === 'image.png' || !!file.contentType?.startsWith('image');
}
